import axios from 'axios';
/**
 *
 * @param url
 * @returns {boolean}
 */
export function isValidUrl(url) {
    // eslint-disable-next-line max-len
    const regex = /^(((https?):)?\/\/)?((.+:.+@)?(([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*)\.)+[A-Za-z]{2,})(\/[\w%@.!$:&=+~-]*)*(\?[\w;&%@.,:=+$~-]*)?$/gm;
    return regex.test(url);
}

/**
 *
 * @param url
 * @return {string|*}
 */
export function addProtocol(url) {
    if (
        url.startsWith('http://') ||
        url.startsWith('https://')
    ) {
        return url;
    }

    return "http://" + url.replace(new RegExp('https?[:/]+', 'i'), '');
}

/**
 * @param url
 * @return {string|*}
 */
export function shortenUrl(url) {
    url = addProtocol(url);

    try {
        return new URL(url).hostname;
    } catch (e) {
        console.error(e);
    }

    return url;
}

export const downloadLandingPageQRCode = async (landingPageUuid) => {
    try {
        const downloadUrl = `${window.env.MILESTONES_API_HOST}/api/v1/landings/pages/${landingPageUuid}/download-qrcode`;
        const response = await axios.get(downloadUrl, {
            responseType: 'blob'
        });

        const filename = response.headers['x-filename'] || 'download.svg';

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading the QR code:', error);
    }
};
